import { getDistance } from "../../util/MathUtil";

export default class StageDrag {
  constructor() {
    this.lastPos = null;
  }

  start(scale) {
    this.startScale = scale;
  }
  move(touch1, touch2, stage, isTablet) {
    // if (this.lastPos)
    //   console.log("touch1", touch1.clientX, touch2.clientX, this.lastPos.clientX);
    let dist = getDistance(
      {
        x: touch1.clientX,
        y: touch1.clientY
      },
      {
        x: touch2.clientX,
        y: touch2.clientY
      }
    );

    if (!this.lastDist) {
      this.lastDist = dist;
    }
    const tmpOffset = this.calcOffset(touch1, touch2);

    let stageScale = stage.scaleX();
    let scale = (stageScale * dist) / this.lastDist;
    this.lastDist = dist;

    // stage.offset({x: -(touch1.clientX - touch2.clientX) / 2 / scaleX, y: (touch1.clientY - touch2.clientY) / 2 / scaleX});

    stage.scale({ x: scale, y: scale });

    let offsetX = stage.offsetX() - tmpOffset.x / scale;
    if (isTablet) {
      if (scale < 0.75)
        scale = 0.75;
      else if (scale > 2.5)
        scale = 2.5;
      if (offsetX <  -300 * scale)
        offsetX = -300 * scale;
      else if (offsetX >  300 * scale)
        offsetX = 300 * scale;
    }

    stage.offsetX(offsetX);
    stage.offsetY(stage.offsetY() - tmpOffset.y / scale);
    // console.log("tmpOffset", tmpOffset.x);

    stage.draw();



    return scale;
  }
  end() {
    this.lastDist = 0;
    this.lastPos = null;
  }

  calcOffset(touch1, touch2) {
    if (!this.lastPos) {
      this.addPos(touch1, touch2);
      return {x: 0, y: 0}
    }

    const current = this.average(touch1, touch2);
    // console.log("lastPos", this.lastPos.clientX, current.clientX, "y", this.lastPos.clientY, current.clientY);
    const result = {
      x: current.clientX - this.lastPos.clientX,
      y: current.clientY - this.lastPos.clientY,
    };
    this.lastPos = current;
    return result;
  }
  average(touch1, touch2) {
    return {clientX: (touch1.clientX + touch2.clientX) * 0.5, clientY: (touch1.clientY + touch2.clientY) * 0.5};
  }
  addPos(touch1, touch2) {
    this.lastPos = this.average(touch1, touch2);
  }
}
